import { render, staticRenderFns } from "./ExplanationStatus.vue?vue&type=template&id=5e392804&scoped=true"
import script from "./ExplanationStatus.vue?vue&type=script&lang=js"
export * from "./ExplanationStatus.vue?vue&type=script&lang=js"
import style0 from "./ExplanationStatus.vue?vue&type=style&index=0&id=5e392804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e392804",
  null
  
)

export default component.exports